export const OperacionWRMFields = {
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    CodOperacion: 'codOperacion',
    CodSectorComercial: 'codSectorComercial',
    NombreSectorComercial: 'nombreSectorComercial',
    FechaEmision: 'fechaEmision',
    FechaVencimiento: 'fechaVencimiento',
    Observaciones: 'observaciones',
    FechaAlta: 'fechaAlta',
    IdUsuarioAlta: 'idUsuarioAlta',
    Detalles: 'detalles',
    BitEnvio: 'enviar',
    PermiteEditar: 'permiteEditarOperacion',
    PermiteEliminar: 'permiteEliminarOperacion',
    NombreUsuarioAlta: 'nombreUsuarioAlta',
    ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
    MailUsuarioAlta: 'mailUsuarioAlta'
} as const
